import React from "react";

import Mail from "assets/img/Group 169.svg";

import "./form-section.styles.scss";

const FormSection = () => {
  return (
    <div className="form-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <h1>
              Get in <span>Touch</span>
            </h1>

            <h3 className="mt-5">Navigate your brand digitally</h3>

            <p className="form-section_description mt-5">
              Brandspire has been helping businesses with <br />
              their digital marketing since the last few years and <br />
              we have successfully discovered the secrets to <br />
              increasing brand awareness and visibility.
            </p>

            <p>Fill in the form to know more.</p>

            <a href="mailto:info@brandspire.com.np">
              <i className="fa-regular fa-envelope mr-3"></i>
              info@brandspire.com.np
            </a>

            <img src={Mail} className="mt-5" alt="mail"></img>
          </div>

          <div className="col-lg-5">
            <div className="form-section_interest"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormSection;
